import { z } from "zod";

import { reference, text } from "@frontend/lib/form/validators";
import { msg } from "@lingui/core/macro";

/**
 * Who, and in what part. Every list that names people names a person and the
 * part they play, so one form serves them all: the person is a contact, an
 * employee or anyone in the address book, depending on the list the window was
 * opened from.
 */
export const interlocutorSchema = z
  .object({
    personId: reference.default(null),
    typeId: reference.default(null),
  })
  .superRefine((values, ctx) => {
    if (null === values.personId) {
      ctx.addIssue({
        code: "custom",
        message: text(msg`Choose a value`),
        path: ["personId"],
      });
    }
  });

export type InterlocutorValues = z.infer<typeof interlocutorSchema>;
